module.exports = function (cookieName, options) {
    //This is a bit hacky, but probably sufficient for now
    const tryDecodeBase64 = (base64String) => {
        try {

            return atob ? atob(base64String) : base64String;
        }
        catch (err) {
            console.log(err);
            //this probably means that the source is just already decoded
            return base64String;
        }
    };
    options = options || {decode:true};
    let name = `${cookieName}=`;
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            const result = c.substring(name.length, c.length);
            return options.decode ? tryDecodeBase64(result) : result;
        }
    }
    // JB:
    // I feel like we should really return null instead of empty string.
    return '';
}
